var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preferences"},[_c('h2',{staticClass:"title is-3"},[_vm._v(_vm._s(_vm.$t("Preferences")))]),_c('db-settings'),(_vm.shouldOfferShareAccess)?_c('share-account-access'):_vm._e(),_c('preferences')],1)}
var staticRenderFns = []

export { render, staticRenderFns }